import { actionKey } from './constants';
import { createAction } from 'redux-actions';
import { PageViewBiEvent } from '@wix/da-bi/pkg/events';

export interface PageViewPayload extends Omit<PageViewBiEvent, 'evid'> {
  /* forces a different event to fire as duperbrowse moved its fire point
     and we needed a way to test historical stat comparisons
  */
  devpageLoadingPhase?: 'phase1' | 'phase1-5' | 'phase2';
}

export const logPageView = createAction(
  `${actionKey}/LOG_PAGEVIEW`,
  (payload: PageViewPayload) => payload
);

// The following action is meant to be fired when unloading a modal that logged a page view event before.
// This lets the parent "page" know that it needs to fire a new page view event, which updates the bi context fields.
export const biModalUnload = createAction(
  `${actionKey}.MODAL_UNLOAD`,
  () => ({})
);
